// import { gql } from "@apollo/client";
import { gql } from "@apollo/client/core";

const CREATE_PROJECT = gql`
  mutation CreateProject($name: String!) {
    createProject(data: { name: $name }) {
      id
      name
    }
  }
`;

const JOIN_PROJECT = gql`
  mutation JoinProject($inviteId: ID!, $hash: String!) {
    joinProject(data: { inviteId: $inviteId, hash: $hash })
  }
`;

const DECLINE_PROJECT_INVITE = gql`
  mutation DeclineProjectInvite($inviteId: ID!) {
    declineProjectInvite(inviteId: $inviteId)
  }
`;

const LEAVE_PROJECT = gql`
  mutation LeaveProject($projectId: ID!) {
    leaveProject(projectId: $projectId)
  }
`;

const CANCEL_PROJECT_INVITE = gql`
  mutation CancelProjectInvite($inviteId: ID!, $projectId: String!) {
    cancelProjectInvite(inviteId: $inviteId, projectID: $projectId)
  }
`;

const REVOKE_PROJECT_MEMBER = gql`
  mutation RevokeProjectMember($projectId: ID!, $userId: ID!) {
    revokeProjectMember(data: { projectId: $projectId, userId: $userId })
  }
`;

const INVITE_PROJECT_MEMBER = gql`
  mutation InviteProjectMember(
    $projectId: ID!
    $email: String!
    $role: RBACRole
  ) {
    inviteProjectMember(
      data: { projectId: $projectId, email: $email, role: $role }
    )
  }
`;

const RESEND_INVITE_PROJECT_MEMBER = gql`
  mutation ResendInviteProjectMember($inviteId: ID!, $projectId: String!) {
    resendInviteProjectMember(inviteId: $inviteId, projectID: $projectId)
  }
`;

const CREATE_SERVICE__TYPE = `createService`;
const CREATE_SERVICE = gql`
  mutation CreateService(
    $projectId: ID!
    $name: String!
    $type: Type!
    $resourceConfig: ResourceConfig
    $vpcId: ID
    $privateLinkConnectionIds: [ID!]
    $enableConnectionPooler: Boolean
    $regionCode: String!
    $forkConfig: ForkConfig
    $environmentTag: ServiceEnvironment
    $isFixed: Boolean
    $servicePlan: ServicePlan
  ) {
    createService(
      data: {
        projectId: $projectId
        name: $name
        type: $type
        resourceConfig: $resourceConfig
        vpcId: $vpcId
        privateLinkConnectionIds: $privateLinkConnectionIds
        enableConnectionPooler: $enableConnectionPooler
        regionCode: $regionCode
        forkConfig: $forkConfig
        environmentTag: $environmentTag
        isFixed: $isFixed
        servicePlan: $servicePlan
      }
    ) {
      service {
        name
        id
        projectId
        servicePlan
        type
        isReadOnly
        regionCode
        endpoints {
          primary {
            host
            port
          }
        }
        spec {
          ... on TimescaleDBServiceSpec {
            hostname
            username
            port
            defaultDBName
            connectionPoolerEnabled
            IOBoostEnabled
            poolerHostName
            poolerPort
            isFixed
          }
        }
        resources {
          id
          spec {
            ... on ResourceNode {
              milliCPU
              memoryGB
              storageGB
              replicaCount
              syncReplicaCount
            }
          }
        }
        status
        vpcId
        vpcEndpoint {
          ... on Endpoint {
            projectId
            serviceId
            vpcId
            host
            port
          }
        }
        metrics {
          ... on ResourceMetrics {
            memoryMB
            storageMB
            milliCPU
          }
        }
        primaryOrdinal
        replicaOrdinals
        replicaStatus
        forkedFromId {
          serviceId
          projectId
        }
        created
      }
      initialPassword
    }
  }
`;

const DISABLE_STATIC_RESOURCES__TYPE = "disableStaticResources";
const DISABLE_STATIC_RESOURCES = gql`
  mutation DisableStaticResources($projectId: ID!, $serviceId: ID!) {
    disableStaticResources(
      data: { projectId: $projectId, serviceId: $serviceId }
    )
  }
`;

const TOGGLE_CROSS_REGION_BACKUPS = gql`
  mutation ToggleCrossRegionBackups(
    $projectId: ID!
    $serviceId: ID!
    $region: String!
    $enable: Boolean!
  ) {
    toggleCrossRegionBackupsV2(
      data: {
        projectID: $projectId
        serviceID: $serviceId
        region: $region
        enable: $enable
      }
    )
  }
`;

const SET_BACKUPS_RETENTION = gql`
  mutation SetBackupsRetention(
    $projectId: ID!
    $serviceId: ID!
    $retType: String!
    $retCount: Int!
  ) {
    setBackupsRetention(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        retType: $retType
        retCount: $retCount
      }
    )
  }
`;

const SET_PROJECT_ENFORCEMENT_TYPE = gql`
  mutation SetProjectEnforcementType(
    $projectId: ID!
    $enforcementType: EnforcementType!
  ) {
    setProjectEnforcementType(
      projectId: $projectId
      enforcementType: $enforcementType
    ) {
      id
      enforcementType
    }
  }
`;

const CREATE_SERVICE_FORK = gql`
  mutation CreateServiceFork(
    $projectId: ID!
    $name: String!
    $type: Type!
    $resourceConfig: ResourceConfig
    $vpcId: ID
    $privateLinkConnectionIds: [ID!]
    $enableConnectionPooler: Boolean
    $regionCode: String!
    $forkConfig: ForkConfig!
    $environmentTag: ServiceEnvironment
    $isFixed: Boolean
    $servicePlan: ServicePlan
  ) {
    createService(
      data: {
        projectId: $projectId
        name: $name
        type: $type
        resourceConfig: $resourceConfig
        vpcId: $vpcId
        privateLinkConnectionIds: $privateLinkConnectionIds
        enableConnectionPooler: $enableConnectionPooler
        regionCode: $regionCode
        forkConfig: $forkConfig
        environmentTag: $environmentTag
        isFixed: $isFixed
        servicePlan: $servicePlan
      }
    ) {
      service {
        name
        id
        projectId
        type
        isReadOnly
        regionCode
        spec {
          ... on TimescaleDBServiceSpec {
            hostname
            username
            port
            defaultDBName
            connectionPoolerEnabled
            IOBoostEnabled
            poolerHostName
            poolerPort
            isFixed
          }
        }
        resources {
          id
          spec {
            ... on ResourceNode {
              milliCPU
              memoryGB
              storageGB
              replicaCount
            }
          }
        }
        status
        vpcId
        vpcEndpoint {
          ... on Endpoint {
            projectId
            serviceId
            vpcId
            host
            port
          }
        }
        metrics {
          ... on ResourceMetrics {
            memoryMB
            storageMB
            milliCPU
          }
        }
        forkedFromId {
          serviceId
          projectId
          isStandby
        }
        created
      }
      initialPassword
    }
  }
`;

const SET_REPLICA_COUNT = gql`
  mutation SetReplicaCount(
    $serviceId: ID!
    $projectId: ID!
    $replicaCount: Int!
    $synchronousReplicaCount: Int
    $allReplicasAreSync: Boolean
  ) {
    setReplicaCount(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        replicaCount: $replicaCount
        synchronousReplicaCount: $synchronousReplicaCount
        allReplicasAreSync: $allReplicasAreSync
      }
    )
  }
`;

const UPGRADE_SERVICE_POSTGRES_MAJOR_VERSION = gql`
  mutation UpgradePostgresMajorVersion(
    $projectId: ID!
    $serviceId: ID!
    $postgresVersion: Int!
  ) {
    upgradePostgresMajorVersion(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        postgresVersion: $postgresVersion
      }
    )
  }
`;

// const CREATE_RESOURCE = gql`
//   mutation CreateResource($serviceId: ID!, $name: String!, $type: String!) {
//     createResource(data: { serviceId: $serviceId, name: $name, type: $type }) {
//       id
//       serviceId
//       name
//       type
//     }
//   }
// `;

const CREATE_USER__TYPE = "createUser";
const CREATE_USER = gql`
  mutation CreateUser(
    $name: String!
    $email: String!
    $password: String!
    $passwordConfirm: String!
    $recaptchaToken: String!
    $inviteHash: String
  ) {
    createUser(
      data: {
        name: $name
        email: $email
        password: $password
        passwordConfirm: $passwordConfirm
        recaptchaToken: $recaptchaToken
        inviteHash: $inviteHash
      }
    ) {
      name
      email
      id
      created
    }
  }
`;

const SET_ENVIRONMENT_TAG__TYPE = "setServiceEnvironmentTag";
const SET_ENVIRONMENT_TAG = gql`
  mutation SetServiceEnvironmentTag(
    $projectId: ID!
    $serviceId: ID!
    $environment: ServiceEnvironment!
  ) {
    setServiceEnvironmentTag(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        environment: $environment
      }
    )
  }
`;

const CREATE_PAYMENT_METHOD__TYPE = "createPaymentMethod";
const CREATE_PAYMENT_METHOD = gql`
  mutation CreatePaymentMethod($billingAccountId: ID!, $isPrimary: Boolean!) {
    createPaymentMethod(
      billingAccountId: $billingAccountId
      isPrimary: $isPrimary
    )
  }
`;

const CREATE_CARD_VERIFICATION_CHARGE = gql`
  mutation CreateCardVerificationCharge($billingAccountId: ID!) {
    createCardVerificationCharge(billingAccountId: $billingAccountId) {
      clientSecret
    }
  }
`;

const UPDATE_PAYMENT_METHOD__TYPE = "updatePaymentMethod";

const UPDATE_PAYMENT_METHOD = gql`
  mutation UpdatePaymentMethod(
    $billingAccountId: ID!
    $paymentMethodId: ID!
    $addressInfo: AddressInfoInput
    $cardExp: CardExpInput!
  ) {
    updatePaymentMethod(
      billingAccountId: $billingAccountId
      paymentMethodId: $paymentMethodId
      addressInfo: $addressInfo
      cardExp: $cardExp
    ) {
      id
      isPrimary
      cardInfo {
        last4
      }
      addressInfo {
        city
        state
        country
        line1
        line2
        postalCode
      }
    }
  }
`;

const DELETE_PAYMENT_METHOD__TYPE = "deletePaymentMethod";
const DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($billingAccountId: ID!, $paymentMethodId: ID!) {
    deletePaymentMethod(
      billingAccountId: $billingAccountId
      paymentMethodId: $paymentMethodId
    ) {
      id
    }
  }
`;

const SET_PRIMARY_PAYMENT_METHOD = gql`
  mutation SetPrimaryPaymentMethod(
    $billingAccountId: ID!
    $paymentMethodId: ID!
  ) {
    setPrimaryPaymentMethod(
      data: {
        billingAccountId: $billingAccountId
        paymentMethodId: $paymentMethodId
      }
    )
  }
`;

const CREATE_BILLING_EMAIL = gql`
  mutation CreateBillingEmailAddress($email: String!, $billingAccountId: ID!) {
    createBillingEmailAddress(
      data: { billingAccountId: $billingAccountId, email: $email }
    ) {
      id
      email
      billingAccountId
      created
      activated
    }
  }
`;

const DELETE_BILLING_EMAIL = gql`
  mutation DeleteBillingEmailAddress(
    $billingEmailId: ID!
    $billingAccountId: ID!
  ) {
    deleteBillingEmailAddress(
      data: {
        billingEmailId: $billingEmailId
        billingAccountId: $billingAccountId
      }
    )
  }
`;

const VERIFY_BILLING_EMAIL = gql`
  mutation VerifyBillingEmailAddress($billingEmailId: ID!, $hash: String!) {
    verifyBillingEmailAddress(
      data: { billingEmailId: $billingEmailId, hash: $hash }
    )
  }
`;

const RESEND_VERIFY_BILLING_EMAIL = gql`
  mutation ResendVerifyBillingEmailAddress(
    $billingEmailId: ID!
    $billingAccountId: ID!
  ) {
    resendVerifyBillingEmailAddress(
      data: {
        billingEmailId: $billingEmailId
        billingAccountId: $billingAccountId
      }
    )
  }
`;

const CANCEL_PENDING_PAYMENT_DELETION = gql`
  mutation CancelPendingPaymentDeletion(
    $billingAccountId: ID!
    $paymentMethodId: ID!
  ) {
    cancelPendingPaymentDeletion(
      data: {
        billingAccountId: $billingAccountId
        paymentMethodId: $paymentMethodId
      }
    )
  }
`;

const CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $oldPassword: String!
    $newPassword: String!
    $newPasswordConfirm: String!
    $trustChallenge: String
    $trustToken: String
  ) {
    changePassword(
      data: {
        oldPassword: $oldPassword
        newPassword: $newPassword
        newPasswordConfirm: $newPasswordConfirm
        trustChallenge: $trustChallenge
        trustToken: $trustToken
      }
    )
  }
`;

const RESET_PASSWORD = gql`
  mutation ResetPassword(
    $password: String!
    $passwordConfirm: String!
    $token: String!
    $trustChallenge: String
    $trustToken: String
  ) {
    resetPassword(
      data: {
        password: $password
        passwordConfirm: $passwordConfirm
        token: $token
        trustChallenge: $trustChallenge
        trustToken: $trustToken
      }
    )
  }
`;

const RESET_SERVICE_PASSWORD = gql`
  mutation ResetServicePassword(
    $serviceId: ID!
    $projectId: ID!
    $password: String!
    $passwordType: PasswordType!
  ) {
    resetServicePassword(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        password: $password
        passwordType: $passwordType
      }
    )
  }
`;

const SEND_NEW_PASSWORD = gql`
  mutation SendPasswordReset($email: String!) {
    sendPasswordReset(email: $email)
  }
`;

const UPDATE_USER = gql`
  mutation UpdateUser($name: String, $phone: String, $uiState: String) {
    updateUser(data: { name: $name, phone: $phone, uiState: $uiState }) {
      id
      name
      email
      phone
      created
      origin
      uiState
      managedByIdp
      managedByIdpReason
    }
  }
`;

const VERIFY_EMAIL = gql`
  mutation VerifyEmail($email: String!, $hash: String!) {
    verifyEmail(data: { email: $email, hash: $hash }) {
      status
      userID
      userToken
      user {
        id
        name
        email
        phone
        created
        managedByIdp
      }
    }
  }
`;

const RESEND_VERIFY_EMAIL = gql`
  mutation ResendVerifyEmail($email: String!) {
    resendVerifyEmail(email: $email)
  }
`;

const DELETE_SERVICE = gql`
  mutation DeleteService($serviceId: ID!, $projectId: ID!) {
    deleteService(data: { serviceId: $serviceId, projectId: $projectId }) {
      id
      name
    }
  }
`;

const TOGGLE_SERVICE = gql`
  mutation ToggleService($serviceId: ID!, $projectId: ID!, $status: Status!) {
    toggleService(
      data: { serviceId: $serviceId, projectId: $projectId, status: $status }
    ) {
      id
      name
      spec {
        ... on TimescaleDBServiceSpec {
          status
        }
      }
    }
  }
`;

const TOGGLE_POPSQL_INTEGRATION = gql`
  mutation TogglePopSQLIntegration(
    $projectId: ID!
    $serviceId: ID!
    $enable: Boolean!
  ) {
    togglePopSQLIntegration(
      data: { projectId: $projectId, serviceId: $serviceId, enable: $enable }
    )
  }
`;

const RESIZE_INSTANCE = gql`
  mutation ResizeInstance(
    $serviceId: ID!
    $projectId: ID!
    $config: ResourceConfig!
  ) {
    resizeInstance(
      data: { serviceId: $serviceId, projectId: $projectId, config: $config }
    )
  }
`;

const SET_ADDRESS_INFO = gql`
  mutation SetAddressInfo(
    $billingAccountId: ID!
    $companyAddress: AddressInfoInput!
  ) {
    setAddressInfo(
      billingAccountId: $billingAccountId
      companyAddress: $companyAddress
    ) {
      companyAddress {
        companyName
        line1
        line2
        city
        state
        country
        postalCode
      }
    }
  }
`;

const SET_POSTGRES_PARAMETERS = gql`
  mutation SetPostgresParameters(
    $serviceId: ID!
    $projectId: ID!
    $numericParameters: [SetNumericParameter!]
    $stringParameters: [SetStringParameter!]
  ) {
    setPostgresParameters(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        numericParameters: $numericParameters
        stringParameters: $stringParameters
      }
    ) {
      name
      errorMessage
    }
  }
`;

const RESET_POSTGRES_PARAMETERS = gql`
  mutation ResetPostgresParameters($serviceId: ID!, $projectId: ID!) {
    resetPostgresParameters(
      data: { serviceId: $serviceId, projectId: $projectId }
    )
  }
`;

const CHANGE_MAINTENANCE_WINDOW__TYPE = "setMaintenanceWindow";
const CHANGE_MAINTENANCE_WINDOW = gql`
  mutation ChangeMaintenanceWindow(
    $projectId: ID!
    $serviceId: ID!
    $start: Time!
    $durationInSeconds: Int!
  ) {
    setMaintenanceWindow(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        start: $start
        durationInSeconds: $durationInSeconds
      }
    )
  }
`;

const CREATE_VPC = gql`
  mutation CreateVpc(
    $projectId: ID!
    $cidr: String!
    $cloudProvider: CloudProvider!
    $name: String!
    $regionCode: String!
  ) {
    createVpc(
      data: {
        projectId: $projectId
        cidr: $cidr
        cloudProvider: $cloudProvider
        name: $name
        regionCode: $regionCode
      }
    ) {
      id
    }
  }
`;

const CONFIGURE_IP_ALLOW_LIST = gql`
  mutation ConfigureIPAllowList(
    $projectId: ID!
    $cidrBlocks: [String!]
    $description: String!
    $listId: Int
  ) {
    configureIPAllowList(
      data: {
        projectId: $projectId
        cidrBlocks: $cidrBlocks
        description: $description
        listId: $listId
      }
    ) {
      listId
    }
  }
`;

const BIND_IP_ALLOW_LIST = gql`
  mutation BindIPAllowList($projectId: ID!, $serviceId: ID!, $listId: Int!) {
    bindIPAllowList(
      data: { projectId: $projectId, serviceId: $serviceId, listId: $listId }
    )
  }
`;

const UNBIND_IP_ALLOW_LIST = gql`
  mutation UnbindIPAllowList($projectId: ID!, $serviceId: ID!, $listId: Int!) {
    unbindIPAllowList(
      data: { projectId: $projectId, serviceId: $serviceId, listId: $listId }
    )
  }
`;

const RENAME_VPC = gql`
  mutation RenameVPC($projectId: ID!, $forgeVpcId: ID!, $newName: String!) {
    renameVpc(
      data: {
        projectId: $projectId
        forgeVpcId: $forgeVpcId
        newName: $newName
      }
    )
  }
`;

const RENAME_SERVICE = gql`
  mutation RenameService($projectId: ID!, $serviceId: ID!, $newName: String!) {
    renameService(
      data: { projectId: $projectId, serviceId: $serviceId, newName: $newName }
    )
  }
`;

const RENAME_PROJECT = gql`
  mutation RenameProject($projectId: ID!, $name: String!) {
    renameProject(data: { projectId: $projectId, name: $name }) {
      id
      name
    }
  }
`;

const DISABLE_PROJECT = gql`
  mutation DisableProject($projectId: ID!) {
    disableProject(data: { projectId: $projectId }) {
      id
      name
    }
  }
`;

const OPEN_PEER_REQUEST = gql`
  mutation OpenPeerRequest(
    $projectId: ID!
    $forgeVpcId: ID!
    $cloudProvider: CloudProvider!
    $peerVpc: InputPeerVPC!
  ) {
    openPeerRequest(
      data: {
        projectId: $projectId
        forgeVpcId: $forgeVpcId
        cloudProvider: $cloudProvider
        peerVpc: $peerVpc
      }
    ) {
      id
    }
  }
`;

const UPDATE_PEERING_CIDRS = gql`
  mutation UpdatePeeringConnectionCIDRs(
    $projectId: ID!
    $forgeVpcId: ID!
    $id: ID!
    $cidrBlocks: [String!]!
  ) {
    updatePeeringConnectionCIDRs(
      data: {
        projectId: $projectId
        forgeVpcId: $forgeVpcId
        id: $id
        cidrBlocks: $cidrBlocks
      }
    )
  }
`;

const DELETE_PEER_CONNECTION = gql`
  mutation DeletePeeringConnection($projectId: ID!, $vpcId: ID!, $id: ID!) {
    deletePeeringConnection(
      data: { projectId: $projectId, vpcId: $vpcId, id: $id }
    )
  }
`;

const ATTACH_SERVICE_TO_VPC = gql`
  mutation AttachServiceToVpc($projectId: ID!, $serviceId: ID!, $vpcId: ID!) {
    attachServiceToVpc(
      data: { projectId: $projectId, serviceId: $serviceId, vpcId: $vpcId }
    )
  }
`;

const DETACH_SERVICE_FROM_VPC = gql`
  mutation DetachServiceFromVpc($projectId: ID!, $serviceId: ID!, $vpcId: ID!) {
    detachServiceFromVpc(
      data: { projectId: $projectId, serviceId: $serviceId, vpcId: $vpcId }
    )
  }
`;

const DELETE_VPC = gql`
  mutation DeleteVpc($projectId: ID!, $vpcId: ID!) {
    deleteVpc(data: { projectId: $projectId, vpcId: $vpcId })
  }
`;

const CREATE_METRIC_EXPORTER__TYPE = "createMetricExporter";

const CREATE_METRIC_EXPORTER = gql`
  mutation CreateMetricExporter(
    $projectId: ID!
    $name: String!
    $config: MetricExporterConfigInput!
    $regionCode: String!
    $enablePgMetrics: Boolean
  ) {
    createMetricExporter(
      data: {
        projectId: $projectId
        name: $name
        config: $config
        regionCode: $regionCode
        enablePgMetrics: $enablePgMetrics
      }
    ) {
      id
      exporterUuid
      projectId
      created
      name
      type
      config {
        ... on CloudWatchMetricConfig {
          logGroupName
          logStreamName
          namespace
          awsRegion
          awsRoleArn
        }
        ... on DatadogMetricConfig {
          apiKey
          site
        }
        ... on PrometheusMetricConfig {
          user
          password
        }
        ... on AzureMonitorMetricConfig {
          connectionString
        }
      }
      enablePgMetrics
    }
  }
`;

const UPDATE_METRIC_EXPORTER__TYPE = "updateMetricExporter";

const UPDATE_METRIC_EXPORTER = gql`
  mutation UpdateMetricExporter(
    $projectId: ID!
    $name: String!
    $config: MetricExporterConfigInput!
    $exporterUuid: String
    $enablePgMetrics: Boolean
  ) {
    updateMetricExporter(
      data: {
        projectId: $projectId
        name: $name
        config: $config
        exporterUuid: $exporterUuid
        enablePgMetrics: $enablePgMetrics
      }
    )
  }
`;

const DELETE_METRIC_EXPORTER__TYPE = "deleteMetricExporter";

const DELETE_METRIC_EXPORTER = gql`
  mutation DeleteMetricExporter($projectId: ID!, $exporterUuid: String) {
    deleteMetricExporter(
      data: { projectId: $projectId, exporterUuid: $exporterUuid }
    )
  }
`;

const ATTACH_SERVICE_TO_METRIC_EXPORTER__TYPE = "attachServiceToMetricExporter";
const ATTACH_SERVICE_TO_METRIC_EXPORTER = gql`
  mutation AttachServiceToMetricExporter(
    $projectId: ID!
    $serviceId: ID!
    $exporterUuid: ID
  ) {
    attachServiceToMetricExporter(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        exporterUuid: $exporterUuid
      }
    )
  }
`;
const DETACH_SERVICE_FROM_METRIC_EXPORTER__TYPE =
  "detachServiceFromMetricExporter";
const DETACH_SERVICE_FROM_METRIC_EXPORTER = gql`
  mutation DetachServiceFromMetricExporter(
    $projectId: ID!
    $serviceId: ID!
    $exporterUuid: ID
  ) {
    detachServiceFromMetricExporter(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        exporterUuid: $exporterUuid
      }
    )
  }
`;

const CREATE_GENERIC_EXPORTER__TYPE = "createGenericExporter";

const CREATE_GENERIC_EXPORTER = gql`
  mutation CreateGenericExporter(
    $projectId: ID!
    $name: String!
    $region: String!
    $type: GenericExporterType!
    $dataType: GenericExporterDataType!
    $config: GenericExporterConfigInput!
  ) {
    createGenericExporter(
      data: {
        projectId: $projectId
        name: $name
        config: $config
        type: $type
        dataType: $dataType
        region: $region
      }
    ) {
      id
      projectId
      regionCode
      created
      name
      type
    }
  }
`;

const UPDATE_GENERIC_EXPORTER__TYPE = "updateGenericExporter";

const UPDATE_GENERIC_EXPORTER = gql`
  mutation UpdateGenericExporter(
    $projectId: ID!
    $exporterId: String!
    $name: String!
    $config: GenericExporterConfigInput!
  ) {
    updateGenericExporter(
      data: {
        projectId: $projectId
        name: $name
        exporterId: $exporterId
        config: $config
      }
    )
  }
`;

const DELETE_GENERIC_EXPORTER__TYPE = "deleteGenericExporter";

const DELETE_GENERIC_EXPORTER = gql`
  mutation DeleteGenericExporter($projectId: ID!, $exporterId: String!) {
    deleteGenericExporter(
      data: { projectId: $projectId, exporterId: $exporterId }
    )
  }
`;

const ATTACH_SERVICE_TO_GENERIC_EXPORTER__TYPE =
  "attachServiceToGenericExporter";

const ATTACH_SERVICE_TO_GENERIC_EXPORTER = gql`
  mutation AttachServiceToGenericExporter(
    $projectId: ID!
    $serviceId: ID!
    $exporterId: String!
  ) {
    attachServiceToGenericExporter(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        exporterId: $exporterId
      }
    )
  }
`;

const DETACH_SERVICE_FROM_GENERIC_EXPORTER__TYPE =
  "detachServiceFromGenericExporter";

const DETACH_SERVICE_FROM_GENERIC_EXPORTER = gql`
  mutation DetachServiceFromGenericExporter(
    $projectId: ID!
    $serviceId: ID!
    $exporterId: String!
  ) {
    detachServiceFromGenericExporter(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        exporterId: $exporterId
      }
    )
  }
`;

const SET_COMPRESSION_HYPERTABLE = gql`
  mutation SetCompressionHypertable(
    $serviceId: ID!
    $projectId: ID!
    $regionCode: String!
    $config: CompressionConfig!
    $tableSchema: ID!
    $tableName: ID!
  ) {
    setCompressionHypertable(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        regionCode: $regionCode
        config: $config
        tableSchema: $tableSchema
        tableName: $tableName
      }
    )
  }
`;

const SET_COMPRESSION__TYPE = "setCompression";
const SET_COMPRESSION = gql`
  mutation SetCompression(
    $serviceId: ID!
    $projectId: ID!
    $regionCode: String!
    $config: CompressionConfig!
    $schema: ID!
    $tableName: ID
    $contAggName: ID
  ) {
    setCompression(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        regionCode: $regionCode
        config: $config
        schema: $schema
        tableName: $tableName
        contAggName: $contAggName
      }
    )
  }
`;

const ADD_COMPRESSION_POLICY = gql`
  mutation AddCompressionPolicy(
    $serviceId: ID!
    $projectId: ID!
    $regionCode: String!
    $tableSchema: ID!
    $tableName: ID
    $contAggName: ID
    $olderThan: String!
  ) {
    addCompressionPolicy(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        regionCode: $regionCode
        tableSchema: $tableSchema
        tableName: $tableName
        contAggName: $contAggName
        olderThan: $olderThan
      }
    )
  }
`;

const DELETE_COMPRESSION_HYPERTABLE = gql`
  mutation DeleteCompressionPolicy(
    $serviceId: ID!
    $projectId: ID!
    $regionCode: String!
    $tableSchema: ID!
    $tableName: ID!
  ) {
    deleteCompressionPolicy(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        regionCode: $regionCode
        tableSchema: $tableSchema
        tableName: $tableName
      }
    )
  }
`;

const ADD_MFA_METHOD = gql`
  mutation AddMfaMethod($code: String!, $secret: String!) {
    addMfaMethod(data: { authenticator: { secret: $secret, code: $code } }) {
      recoveryCodes
      method {
        ... on AuthenticatorMethod {
          id
        }
      }
    }
  }
`;

const DELETE_MFA_METHOD = gql`
  mutation DeleteMfaMethod($id: ID!, $code: String!) {
    deleteMfaMethod(data: { id: $id, code: $code })
  }
`;

const REGENERATE_MFA_RECOVERY_CODES = gql`
  mutation RegenerateRecoveryCodes($code: String!) {
    regenerateRecoveryCodes(data: { code: $code })
  }
`;

const CREATE_SUPPORT_TICKET__TYPE = "createSupportTicket";
const CREATE_SUPPORT_TICKET = gql`
  mutation CreateSupportTicket(
    $projectId: ID!
    $services: [SupportServiceInfoInput!]
    $subject: String!
    $description: String!
    $email: String!
    $userId: ID!
    $name: String!
    $caseType: SupportCaseType
    $billingCategory: SupportBillingCategory
    $stillHappening: SupportStillHappening
    $reportedServiceCapability: SupportServiceCapability
    $isProduction: Boolean
    $impact: String
    $attachments: [Upload!]
  ) {
    createSupportTicket(
      data: {
        projectId: $projectId
        services: $services
        subject: $subject
        description: $description
        email: $email
        userId: $userId
        name: $name
        caseType: $caseType
        billingCategory: $billingCategory
        stillHappening: $stillHappening
        reportedServiceCapability: $reportedServiceCapability
        isProduction: $isProduction
        impact: $impact
        attachments: $attachments
      }
    )
  }
`;

const ADD_SUPPORT_CASE_REPLY__TYPE = "addSupportCaseReply";
const ADD_SUPPORT_CASE_REPLY = gql`
  mutation AddSupportCaseReply(
    $caseId: ID!
    $projectId: ID!
    $body: String!
    $attachments: [Upload!]
  ) {
    addSupportCaseReply(
      data: {
        caseId: $caseId
        projectId: $projectId
        body: $body
        attachments: $attachments
      }
    ) {
      fromName
      incoming
      textBody
      messageDate
      attachments {
        contentDocumentId
        title
        fileExtension
        contentSize
        url
      }
    }
  }
`;

const CLOSE_SUPPORT_CASE__TYPE = "closeSupportCase";
const CLOSE_SUPPORT_CASE = gql`
  mutation CloseSupportCase(
    $caseId: ID!
    $projectId: ID!
    $body: String
    $attachments: [Upload!]
  ) {
    closeSupportCase(
      data: {
        caseId: $caseId
        projectId: $projectId
        body: $body
        attachments: $attachments
      }
    )
  }
`;

const TOGGLE_DATA_TIERING_INPUT = gql`
  mutation ToggleDataTieringInput(
    $serviceId: ID!
    $projectId: ID!
    $enable: Boolean!
  ) {
    toggleDataTiering(
      data: { serviceId: $serviceId, projectId: $projectId, enable: $enable }
    )
  }
`;

const CREATE_PAT_RECORD__TYPE = "createPATRecord";
const CREATE_PAT_RECORD = gql`
  mutation CreatePATRecord($projectId: ID!, $name: String!) {
    createPATRecord(
      createPATRecordInput: { projectId: $projectId, name: $name }
    ) {
      clientCredentials {
        accessKey
        secretKey
      }
      name
      projectId
      created
    }
  }
`;

const DELETE_PAT_RECORD__TYPE = "deletePATRecord";
const DELETE_PAT_RECORD = gql`
  mutation DeletePATRecord($accessKey: String!, $projectId: ID!) {
    deletePATRecord(
      deletePATRecordInput: { accessKey: $accessKey, projectId: $projectId }
    )
  }
`;

const RENAME_PAT_RECORD__TYPE = "renamePATRecord";
const RENAME_PAT_RECORD = gql`
  mutation RenamePATRecord(
    $accessKey: String!
    $newName: String!
    $projectId: ID!
  ) {
    renamePATRecord(
      renamePATRecordInput: {
        accessKey: $accessKey
        newName: $newName
        projectId: $projectId
      }
    )
  }
`;

const TOGGLE_CONNECTION_POOLER = gql`
  mutation ToggleConnectionPooler(
    $serviceId: ID!
    $projectId: ID!
    $enable: Boolean!
  ) {
    toggleConnectionPooler(
      data: { serviceId: $serviceId, projectId: $projectId, enable: $enable }
    )
  }
`;

const TOGGLE_IO_BOOST = gql`
  mutation ToggleIOBoost(
    $serviceId: ID!
    $projectId: ID!
    $enable: Boolean!
    $storageType: StorageType!
  ) {
    toggleIOBoost(
      data: {
        serviceId: $serviceId
        projectId: $projectId
        enable: $enable
        storageType: $storageType
      }
    )
  }
`;

const TRANSFER_PROJECT_OWNERSHIP__TYPE = "transferProjectOwnership";
const TRANSFER_PROJECT_OWNERSHIP = gql`
  mutation TransferProjectOwnership(
    $projectId: ID!
    $newOwnerId: ID!
    $mfaCode: String!
    $password: String!
  ) {
    transferProjectOwnership(
      data: {
        projectId: $projectId
        newOwnerId: $newOwnerId
        mfaCode: $mfaCode
        password: $password
      }
    )
  }
`;

/// POSTGRES GA MUTATIONS
const CREATE_CONNECTOR__TYPE = "createConnector";
const CREATE_CONNECTOR = gql`
  mutation CreateConnector($data: CreateConnectorInput!) {
    connectors {
      createConnector(data: $data) {
        id
      }
    }
  }
`;

const UPDATE_CONNECTOR_V2__TYPE = "updateConnector";
const UPDATE_CONNECTOR_V2 = gql`
  mutation UpdateConnectorV2($data: UpdateConnectorV2Input!) {
    connectors {
      updateConnectorV2(data: $data) {
        connector {
          displayName
        }
      }
    }
  }
`;

const CREATE_SSH_TUNNEL_CONFIG__TYPE = "createSSHTunnelConfig";
const CREATE_SSH_TUNNEL_CONFIG = gql`
  mutation CreateSSHTunnelConfig($data: CreateSSHTunnelConfigInput!) {
    connectors {
      createSSHTunnelConfig(data: $data) {
        sshTunnelConfig {
          sshTunnelId
          projectId
          name
          publicKey
          username
          host
          port
          createdAt
          updatedAt
        }
      }
    }
  }
`;

const UPDATE_SSH_TUNNEL_CONFIG__TYPE = "updateSSHTunnelConfig";
const UPDATE_SSH_TUNNEL_CONFIG = gql`
  mutation UpdateSSHTunnelConfig($data: UpdateSSHTunnelConfigInput!) {
    connectors {
      updateSSHTunnelConfig(data: $data) {
        sshTunnelConfig {
          sshTunnelId
          projectId
          name
          publicKey
          username
          host
          port
          createdAt
          updatedAt
        }
      }
    }
  }
`;

const CREATE_PG_SRC_CONFIG__TYPE = "createPgSrcConfig";
const CREATE_PG_SRC_CONFIG = gql`
  mutation CreatePgSrcConfig($data: CreatePgSrcConfigInput!) {
    connectors {
      createPgSrcConfig(data: $data) {
        sourceConfig {
          sourceId
        }
      }
    }
  }
`;

const UPDATE_PG_SRC_CONFIG__TYPE = "updatePgSrcConfig";
const UPDATE_PG_SRC_CONFIG = gql`
  mutation UpdatePgSrcConfig($data: UpdatePgSrcConfigInput!) {
    connectors {
      updatePgSrcConfig(data: $data) {
        sourceConfig {
          sourceId
        }
      }
    }
  }
`;

const CREATE_KAFKA_CLUSTER_CONFIG__TYPE = "createKafkaClusterConfig";
const CREATE_KAFKA_CLUSTER_CONFIG = gql`
  mutation CreateKafkaClusterConfig($data: CreateKafkaClusterConfigInput!) {
    connectors {
      createKafkaClusterConfig(data: $data) {
        clusterConfig {
          clusterId
          projectId
          name
          created
          updated
        }
      }
    }
  }
`;

const CREATE_KAFKA_SCHEMA_REGISTRY__TYPE = "createSchemaRegistryConfig";
const CREATE_KAFKA_SCHEMA_REGISTRY = gql`
  mutation CreateSchemaRegistryConfig($data: CreateSchemaRegistryConfigInput!) {
    connectors {
      createSchemaRegistryConfig(data: $data) {
        schemaRegistryConfig {
          schemaRegistryId
        }
      }
    }
  }
`;

const CREATE_KAFKA_CONNECTOR__TYPE = "createKafkaConnector";
const CREATE_KAFKA_CONNECTOR = gql`
  mutation CreateKafkaConnector($data: CreateKafkaConnectorInput!) {
    connectors {
      createKafkaConnector(data: $data) {
        id
      }
    }
  }
`;

const UPDATE_CONNECTOR__TYPE = "updateConnector";
const UPDATE_CONNECTOR = gql`
  mutation UpdateConnector($data: UpdateConnectorInput!) {
    connectors {
      updateConnector(data: $data) {
        connector {
          displayName
        }
      }
    }
  }
`;

const CREATE_S3_LIVESYNC__TYPE = "createS3LiveSync";
const CREATE_S3_LIVESYNC = gql`
  mutation CreateS3LiveSync($data: CreateS3LiveSyncInput!) {
    connectors {
      createS3LiveSync(data: $data)
    }
  }
`;

const UPDATE_S3_LIVESYNC__TYPE = "updateS3LiveSync";
const UPDATE_S3_LIVESYNC = gql`
  mutation UpdateS3LiveSync($data: UpdateS3LiveSyncInput!) {
    connectors {
      updateS3LiveSync(data: $data) {
        id
        name
        pattern
        created_at
        updated_at
        enabled
        bucket
        credentials {
          type
          role {
            arn
          }
        }
        settings {
          on_conflict_do_nothing
        }
        last_imported_object
        definition {
          type
          csv {
            column_names
            delimiter
            skip_header
          }
        }
        table_identifier {
          table_name
          schema_name
        }
        frequency
      }
    }
  }
`;

const DELETE_S3_LIVESYNC__TYPE = "deleteS3LiveSync";
const DELETE_S3_LIVESYNC = gql`
  mutation DeleteS3LiveSync($projectId: ID!, $serviceId: ID!, $id: ID!) {
    connectors {
      deleteS3LiveSync(
        data: { project_id: $projectId, service_id: $serviceId, id: $id }
      )
    }
  }
`;

const DELETE_CONNECTOR__TYPE = "deleteConnector";
const DELETE_CONNECTOR = gql`
  mutation DeleteConnector($data: DeleteConnectorInput!) {
    connectors {
      deleteConnector(data: $data) {
        success
      }
    }
  }
`;

const RETRY_S3_LIVESYNC_FILE_IMPORTS__TYPE = "retryS3LiveSyncFileImports";
const RETRY_S3_LIVESYNC_FILE_IMPORTS = gql`
  mutation RetryS3LiveSyncFileImports($data: RetryS3LiveSyncFileImportsInput!) {
    connectors {
      retryS3LiveSyncFileImports(data: $data) {
        count
      }
    }
  }
`;

const UPDATE_KAFKA_CONNECTOR__TYPE = "updateConnector";
const UPDATE_KAFKA_CONNECTOR = gql`
  mutation UpdateKafkaConnector($data: UpdateConnectorInput!) {
    connectors {
      updateConnector(data: $data) {
        connector {
          displayName
        }
      }
    }
  }
`;

const VALIDATE_ICEBERG_DST__TYPE = "validateConnectorSpecIcebergDst";
const VALIDATE_ICEBERG_DST = gql`
  mutation ValidateIcebergDst($data: ValidateIcebergDstInput!) {
    connectors {
      validateConnectorSpecIcebergDst(data: $data) {
        valid
        validationMessage
      }
    }
  }
`;

const VALIDATE_CONNECTOR_CONFIG_PG_SRC__TYPE = "validateConnectorConfigPgSrc";
const VALIDATE_CONNECTOR_CONFIG_PG_SRC = gql`
  mutation ValidateConnectorConfigPgSrc(
    $data: ValidateConnectorConfigPgSrcInput!
  ) {
    connectors {
      validateConnectorConfigPgSrc(data: $data) {
        valid
        errors
        warnings
      }
    }
  }
`;

const SET_VIRTUAL_PLAN_FOR_PROJECT__TYPE = "setVirtualPlanForProject";
const SET_VIRTUAL_PLAN_FOR_PROJECT = gql`
  mutation SetVirtualPlanForProject(
    $projectId: ID!
    $virtualPlanKind: VirtualPlanType!
    $trialPackage: TrialPackage
  ) {
    setVirtualPlanForProject(
      data: {
        projectId: $projectId
        virtualPlanKind: $virtualPlanKind
        trialPackage: $trialPackage
      }
    )
  }
`;

const SET_HYPERTABLE_CONFIG__TYPE = "";
const SET_HYPERTABLE_CONFIG = gql`
  mutation SetHypertableConf(
    $projectId: ID!
    $serviceId: ID!
    $schema: ID!
    $tableName: ID!
    $chunkSizeIntervalDuration: String!
  ) {
    setHypertableConf(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        schema: $schema
        tableName: $tableName
        chunkSizeIntervalDuration: $chunkSizeIntervalDuration
      }
    )
  }
`;

const SET_HYPERTABLE_CONFIG_AND_TOGGLE_CHUNK_TUNING__TYPE = "";
const SET_HYPERTABLE_CONFIG_AND_TOGGLE_CHUNK_TUNING = gql`
  mutation SetHypertableConfAndToggleChunkTuning(
    $projectId: ID!
    $serviceId: ID!
    $schema: ID!
    $tableName: ID!
    $chunkSizeIntervalDuration: String!
    $tuningProjectId: String!
    $tuningServiceId: String!
    $hypertableId: Int!
    $enabled: Boolean!
  ) {
    setHypertableConf(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        schema: $schema
        tableName: $tableName
        chunkSizeIntervalDuration: $chunkSizeIntervalDuration
      }
    )
    toggleChunkTuning(
      projectId: $tuningProjectId
      serviceId: $tuningServiceId
      hypertableId: $hypertableId
      enabled: $enabled
    )
  }
`;

const DISMISS_RECOMMENDATION__TYPE = "dismissRecommendation";
const DISMISS_RECOMMENDATION = gql`
  mutation DismissRecommendation(
    $projectId: ID!
    $serviceId: ID!
    $recommendationId: ID!
  ) {
    dismissRecommendation(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        recommendationId: $recommendationId
      }
    )
  }
`;

const LINK_MARKETPLACE_ACCOUNT__TYPE = "linkMarketplaceAccount";
const LINK_MARKETPLACE_ACCOUNT = gql`
  mutation LinkMarketplaceAccount($projectId: ID!) {
    linkMarketplaceAccount(data: { projectId: $projectId }) {
      success
    }
  }
`;

const GENERATE_PRESIGNED_URL__TYPE = "generatePresignedURL";
const GENERATE_PRESIGNED_URL = gql`
  mutation GeneratePresignedURL($data: GeneratePresignedURLInput!) {
    connectors {
      generatePresignedURL(data: $data) {
        url
      }
    }
  }
`;

const CREATE_SCHEMA__TYPE = "createSchema";
const CREATE_SCHEMA = gql`
  mutation CreateSchema($data: CreateSchemaInput!) {
    connectors {
      createSchema(data: $data) {
        migration
      }
    }
  }
`;

const CREATE_FILE_IMPORT__TYPE = "createFileImport";
const CREATE_FILE_IMPORT = gql`
  mutation CreateFileImport($data: CreateFileImportInput!) {
    connectors {
      createFileImport(data: $data) {
        error
      }
    }
  }
`;

const UPDATE_FILE_IMPORT__TYPE = "updateFileImport";
const UPDATE_FILE_IMPORT = gql`
  mutation UpdateFileImport($data: UpdateFileImportInput!) {
    connectors {
      updateFileImport(data: $data) {
        error
      }
    }
  }
`;

const CANCEL_CURRENT_QUERY__TYPE = "cancelCurrentQuery";
const CANCEL_CURRENT_QUERY = gql`
  mutation CancelCurrentQuery(
    $serviceId: String!
    $projectId: String!
    $pid: Int!
  ) {
    cancelCurrentQuery(serviceId: $serviceId, projectId: $projectId, pid: $pid)
  }
`;

const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($role: RBACRole!, $projectId: String!, $userId: ID!) {
    updateUserRole(
      input: { role: $role, projectId: $projectId, userId: $userId }
    )
  }
`;

const REQUEST_AUTHORIZATION_CODE__TYPE = "requestAuthorizationCode";
const REQUEST_AUTHORIZATION_CODE = gql`
  mutation RequestAuthorizationCode($data: AuthorizationCodeInput!) {
    requestAuthorizationCode(data: $data) {
      code
    }
  }
`;

const APPROVE_DEVICE_AUTHORIZATION__TYPE = "approveDeviceAuthorization";
const APPROVE_DEVICE_AUTHORIZATION = gql`
  mutation ApproveDeviceAuthorization($userCode: String!) {
    approveDeviceAuthorization(userCode: $userCode)
  }
`;

const TOGGLE_CHUNK_TUNING__TYPE = "toggleChunkTuning";
const TOGGLE_CHUNK_TUNING = gql`
  mutation ToggleChunkTuning(
    $projectId: String!
    $serviceId: String!
    $hypertableId: Int!
    $enabled: Boolean!
  ) {
    toggleChunkTuning(
      projectId: $projectId
      serviceId: $serviceId
      hypertableId: $hypertableId
      enabled: $enabled
    )
  }
`;

const UPDATE_PRIVATE_LINK_CONNECTION = gql`
  mutation UpdatePrivateLinkConnection(
    $projectId: ID!
    $connectionId: ID!
    $name: String
    $ipAddress: String
  ) {
    updatePrivateLinkConnection(
      data: {
        projectId: $projectId
        connectionId: $connectionId
        name: $name
        ipAddress: $ipAddress
      }
    ) {
      connectionId
      principalId
      cloudProvider
      linkIdentifier
      state
      ipAddress
      name
      providerConnectionId
      region
      bindings {
        projectId
        serviceId
        connectionId
        bindingType
        port
        hostname
      }
    }
  }
`;

const CLAIM_PRIVATE_LINK_CONNECTION = gql`
  mutation ClaimPrivateLinkConnection(
    $projectId: ID!
    $claimIdentifier: String!
  ) {
    claimPrivateLinkConnection(
      data: { projectId: $projectId, claimIdentifier: $claimIdentifier }
    ) {
      connectionId
      principalId
      cloudProvider
      linkIdentifier
      state
      ipAddress
      name
      providerConnectionId
      region
      bindings {
        projectId
        serviceId
        connectionId
        bindingType
        port
        hostname
      }
    }
  }
`;

const DELETE_PRIVATE_LINK_CONNECTION = gql`
  mutation DeletePrivateLinkConnection($projectId: ID!, $connectionId: ID!) {
    deletePrivateLinkConnection(
      data: { projectId: $projectId, connectionId: $connectionId }
    )
  }
`;
const ATTACH_SERVICE_TO_PRIVATE_LINK = gql`
  mutation AttachServiceToPrivateLink(
    $projectId: ID!
    $serviceId: ID!
    $connectionIds: [ID!]!
  ) {
    attachServiceToPrivateLinkConnection(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        connectionIds: $connectionIds
      }
    )
  }
`;

const DETACH_SERVICE_FROM_PRIVATE_LINK = gql`
  mutation DetachServiceFromPrivateLink(
    $projectId: ID!
    $serviceId: ID!
    $connectionIds: [ID!]!
  ) {
    detachServiceFromPrivateLinkConnection(
      data: {
        projectId: $projectId
        serviceId: $serviceId
        connectionIds: $connectionIds
      }
    )
  }
`;

const SYNC_PRIVATE_LINK_CONNECTIONS = gql`
  mutation SyncPrivateLinkConnections($projectId: ID!) {
    syncPrivateLinkConnections(data: { projectId: $projectId })
  }
`;

const REVOKE_SESSION = gql`
  mutation RevokeSession($sid: String!) {
    revokeSession(sid: $sid)
  }
`;

const REVOKE_SESSION__TYPE = "revokeSession";

const REVOKE_OTHER_SESSIONS = gql`
  mutation RevokeOtherSessions {
    revokeOtherSessions
  }
`;

const REVOKE_OTHER_SESSIONS__TYPE = "revokeOtherSessions";

const DELETE_ALL_CUSTOMER_DATA = gql`
  mutation DeleteAllCustomerData {
    deleteAllCustomerData {
      userQueuedForDeletion
    }
  }
`;

export {
  CHANGE_PASSWORD,
  CHANGE_MAINTENANCE_WINDOW,
  CHANGE_MAINTENANCE_WINDOW__TYPE,
  CREATE_PROJECT,
  SET_PROJECT_ENFORCEMENT_TYPE,
  CREATE_SERVICE_FORK,
  CREATE_SERVICE,
  CREATE_SERVICE__TYPE,
  DISABLE_STATIC_RESOURCES__TYPE,
  DISABLE_STATIC_RESOURCES,
  TOGGLE_CROSS_REGION_BACKUPS,
  SET_BACKUPS_RETENTION,
  SET_REPLICA_COUNT,
  // CREATE_RESOURCE,
  CREATE_SUPPORT_TICKET,
  CREATE_SUPPORT_TICKET__TYPE,
  ADD_SUPPORT_CASE_REPLY,
  ADD_SUPPORT_CASE_REPLY__TYPE,
  CLOSE_SUPPORT_CASE,
  CLOSE_SUPPORT_CASE__TYPE,
  CREATE_USER,
  CREATE_USER__TYPE,
  SET_ENVIRONMENT_TAG,
  SET_ENVIRONMENT_TAG__TYPE,
  CREATE_PAYMENT_METHOD,
  CREATE_PAYMENT_METHOD__TYPE,
  CREATE_CARD_VERIFICATION_CHARGE,
  UPDATE_PAYMENT_METHOD,
  UPDATE_PAYMENT_METHOD__TYPE,
  SET_PRIMARY_PAYMENT_METHOD,
  CREATE_BILLING_EMAIL,
  DELETE_BILLING_EMAIL,
  VERIFY_BILLING_EMAIL,
  RESEND_VERIFY_BILLING_EMAIL,
  CANCEL_PENDING_PAYMENT_DELETION,
  JOIN_PROJECT,
  DECLINE_PROJECT_INVITE,
  LEAVE_PROJECT,
  CANCEL_PROJECT_INVITE,
  REVOKE_PROJECT_MEMBER,
  INVITE_PROJECT_MEMBER,
  RESEND_INVITE_PROJECT_MEMBER,
  DELETE_SERVICE,
  DELETE_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD__TYPE,
  RENAME_SERVICE,
  RENAME_VPC,
  RENAME_PROJECT,
  DISABLE_PROJECT,
  RESET_PASSWORD,
  RESET_SERVICE_PASSWORD,
  RESEND_VERIFY_EMAIL,
  RESIZE_INSTANCE,
  SEND_NEW_PASSWORD,
  SET_ADDRESS_INFO,
  SET_POSTGRES_PARAMETERS,
  RESET_POSTGRES_PARAMETERS,
  TOGGLE_SERVICE,
  TOGGLE_POPSQL_INTEGRATION,
  UPDATE_USER,
  VERIFY_EMAIL,
  CREATE_VPC,
  DELETE_VPC,
  CONFIGURE_IP_ALLOW_LIST,
  BIND_IP_ALLOW_LIST,
  UNBIND_IP_ALLOW_LIST,
  OPEN_PEER_REQUEST,
  DELETE_PEER_CONNECTION,
  ATTACH_SERVICE_TO_VPC,
  DETACH_SERVICE_FROM_VPC,
  UPGRADE_SERVICE_POSTGRES_MAJOR_VERSION,
  CREATE_METRIC_EXPORTER,
  CREATE_METRIC_EXPORTER__TYPE,
  UPDATE_METRIC_EXPORTER,
  UPDATE_METRIC_EXPORTER__TYPE,
  DELETE_METRIC_EXPORTER,
  DELETE_METRIC_EXPORTER__TYPE,
  CREATE_GENERIC_EXPORTER,
  CREATE_GENERIC_EXPORTER__TYPE,
  UPDATE_GENERIC_EXPORTER,
  UPDATE_GENERIC_EXPORTER__TYPE,
  DELETE_GENERIC_EXPORTER,
  DELETE_GENERIC_EXPORTER__TYPE,
  ATTACH_SERVICE_TO_GENERIC_EXPORTER,
  ATTACH_SERVICE_TO_GENERIC_EXPORTER__TYPE,
  DETACH_SERVICE_FROM_GENERIC_EXPORTER,
  DETACH_SERVICE_FROM_GENERIC_EXPORTER__TYPE,
  ATTACH_SERVICE_TO_METRIC_EXPORTER,
  ATTACH_SERVICE_TO_METRIC_EXPORTER__TYPE,
  DETACH_SERVICE_FROM_METRIC_EXPORTER,
  DETACH_SERVICE_FROM_METRIC_EXPORTER__TYPE,
  SET_COMPRESSION_HYPERTABLE,
  SET_COMPRESSION,
  SET_COMPRESSION__TYPE,
  ADD_COMPRESSION_POLICY,
  DELETE_COMPRESSION_HYPERTABLE,
  ADD_MFA_METHOD,
  DELETE_MFA_METHOD,
  REGENERATE_MFA_RECOVERY_CODES,
  TOGGLE_DATA_TIERING_INPUT,
  CREATE_PAT_RECORD,
  CREATE_PAT_RECORD__TYPE,
  DELETE_PAT_RECORD,
  DELETE_PAT_RECORD__TYPE,
  RENAME_PAT_RECORD,
  RENAME_PAT_RECORD__TYPE,
  TOGGLE_CONNECTION_POOLER,
  TOGGLE_IO_BOOST,
  TRANSFER_PROJECT_OWNERSHIP,
  TRANSFER_PROJECT_OWNERSHIP__TYPE,
  CREATE_KAFKA_CLUSTER_CONFIG,
  CREATE_KAFKA_CLUSTER_CONFIG__TYPE,
  CREATE_KAFKA_SCHEMA_REGISTRY,
  CREATE_KAFKA_SCHEMA_REGISTRY__TYPE,
  CREATE_KAFKA_CONNECTOR,
  CREATE_KAFKA_CONNECTOR__TYPE,
  UPDATE_CONNECTOR__TYPE,
  UPDATE_CONNECTOR,
  DELETE_CONNECTOR__TYPE,
  DELETE_CONNECTOR,
  CREATE_S3_LIVESYNC__TYPE,
  CREATE_S3_LIVESYNC,
  UPDATE_S3_LIVESYNC__TYPE,
  UPDATE_S3_LIVESYNC,
  DELETE_S3_LIVESYNC__TYPE,
  DELETE_S3_LIVESYNC,
  RETRY_S3_LIVESYNC_FILE_IMPORTS__TYPE,
  RETRY_S3_LIVESYNC_FILE_IMPORTS,
  UPDATE_CONNECTOR_V2__TYPE,
  UPDATE_CONNECTOR_V2,
  CREATE_CONNECTOR__TYPE,
  CREATE_CONNECTOR,
  CREATE_PG_SRC_CONFIG__TYPE,
  CREATE_PG_SRC_CONFIG,
  UPDATE_PG_SRC_CONFIG__TYPE,
  UPDATE_PG_SRC_CONFIG,
  CREATE_SCHEMA__TYPE,
  CREATE_SCHEMA,
  CREATE_SSH_TUNNEL_CONFIG__TYPE,
  CREATE_SSH_TUNNEL_CONFIG,
  UPDATE_SSH_TUNNEL_CONFIG__TYPE,
  UPDATE_SSH_TUNNEL_CONFIG,
  SET_VIRTUAL_PLAN_FOR_PROJECT,
  SET_VIRTUAL_PLAN_FOR_PROJECT__TYPE,
  SET_HYPERTABLE_CONFIG,
  SET_HYPERTABLE_CONFIG__TYPE,
  SET_HYPERTABLE_CONFIG_AND_TOGGLE_CHUNK_TUNING,
  SET_HYPERTABLE_CONFIG_AND_TOGGLE_CHUNK_TUNING__TYPE,
  DISMISS_RECOMMENDATION__TYPE,
  DISMISS_RECOMMENDATION,
  UPDATE_PEERING_CIDRS,
  LINK_MARKETPLACE_ACCOUNT__TYPE,
  LINK_MARKETPLACE_ACCOUNT,
  GENERATE_PRESIGNED_URL__TYPE,
  GENERATE_PRESIGNED_URL,
  CREATE_FILE_IMPORT__TYPE,
  CREATE_FILE_IMPORT,
  UPDATE_FILE_IMPORT__TYPE,
  UPDATE_FILE_IMPORT,
  CANCEL_CURRENT_QUERY__TYPE,
  CANCEL_CURRENT_QUERY,
  UPDATE_USER_ROLE,
  REQUEST_AUTHORIZATION_CODE__TYPE,
  REQUEST_AUTHORIZATION_CODE,
  APPROVE_DEVICE_AUTHORIZATION__TYPE,
  APPROVE_DEVICE_AUTHORIZATION,
  VALIDATE_ICEBERG_DST__TYPE,
  VALIDATE_ICEBERG_DST,
  TOGGLE_CHUNK_TUNING__TYPE,
  TOGGLE_CHUNK_TUNING,
  UPDATE_PRIVATE_LINK_CONNECTION,
  CLAIM_PRIVATE_LINK_CONNECTION,
  DELETE_PRIVATE_LINK_CONNECTION,
  ATTACH_SERVICE_TO_PRIVATE_LINK,
  DETACH_SERVICE_FROM_PRIVATE_LINK,
  SYNC_PRIVATE_LINK_CONNECTIONS,
  UPDATE_KAFKA_CONNECTOR__TYPE,
  UPDATE_KAFKA_CONNECTOR,
  VALIDATE_CONNECTOR_CONFIG_PG_SRC__TYPE,
  VALIDATE_CONNECTOR_CONFIG_PG_SRC,
  REVOKE_SESSION,
  REVOKE_SESSION__TYPE,
  REVOKE_OTHER_SESSIONS,
  REVOKE_OTHER_SESSIONS__TYPE,
  DELETE_ALL_CUSTOMER_DATA,
};
